export const PlusIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 7V17M17 12H7" stroke="#14191F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
